export class CardInfo {
  public title: string;
  public text: string;
  public isReplacementApplication: boolean;
}
